export const DATA = {
  "Skill level": "Beginner",
  "Time to complete": "Approx. 60 hours",
  Certificate: "Included",
  Prerequesties: "None",
  description: "Build Coding Skills from Basics to Applications",
  about:
    "Master the fundamentals of Python programming through hands-on coding. This course covers core and advanced concepts, data structures, and real-world applications—equipping you to write clean, efficient code for software development and automation tasks.",
  skills: ["Logical Thinking", "Project Development", "Debugging Techniques"],
  reviews: {
    1: {
      name: "Lara Mendes",
      review:
        "This Python course was far better than I expected. Each concept was broken down into simple explanations, and the examples were practical enough to apply immediately. A very smooth learning experience.",
    },
    2: {
      name: "Ethan Cole",
      review:
        "Great introduction to Python! The instructor made even the beginner topics enjoyable. The regular coding exercises helped me stay consistent and build real confidence.",
    },
    3: {
      name: "Priyanka Dev",
      review:
        "The lessons were so clear and concise. I appreciated how every topic built on the last one. By the end, I was writing scripts comfortably on my own.",
    },
    4: {
      name: "Martin Blake",
      review:
        "I loved the practical approach. Instead of just theory, each section included hands-on tasks that helped me understand how Python works in real projects.",
    },
    5: {
      name: "Sofia Alvarez",
      review:
        "This course exceeded expectations. The instructor explained loops, conditions, and functions in a way that made them easy to grasp. Perfect for beginners.",
    },
    6: {
      name: "Kenji Nakamura",
      review:
        "Very straightforward and engaging. The examples kept me motivated, and the challenges at the end of each lesson helped reinforce everything I learned.",
    },
    7: {
      name: "Aaliyah Price",
      review:
        "The course was incredibly beginner-friendly. I had zero programming experience, and now I feel confident writing Python programs on my own.",
    },
    8: {
      name: "Marco Santino",
      review:
        "Amazing course! The explanations were crystal clear, and the coding demonstrations made everything easy to follow. Highly recommended.",
    },
    9: {
      name: "Hana Thompson",
      review:
        "This course made Python feel accessible and fun. The instructor used real-life examples which helped me understand how Python is used in the real world.",
    },
    10: {
      name: "Rishi Pradhan",
      review:
        "I appreciated the pace and structure. Nothing felt rushed, and the lessons were broken into digestible sections. Great for structured learners like me.",
    },
    11: {
      name: "Emily Carter",
      review:
        "The hands-on exercises and clear explanations made this course enjoyable. I especially loved the mini-projects—they boosted my confidence a lot.",
    },
    12: {
      name: "Omar Haddad",
      review:
        "Very easy to follow! This course made Python concepts like lists, dictionaries, and functions feel simple instead of overwhelming.",
    },
    13: {
      name: "Mila Novak",
      review:
        "One of the best beginner tutorials I’ve taken. The instructor is patient, detailed, and very thorough in explaining Python fundamentals.",
    },
    14: {
      name: "Samuel Reed",
      review:
        "The examples were practical and relatable. I was able to start writing small programs within just a few lessons. Excellent teaching style.",
    },
    15: {
      name: "Diana Torres",
      review:
        "I loved how everything was explained in plain language. This course gave me the confidence to continue learning more advanced Python topics.",
    },
    16: {
      name: "Isaac Romero",
      review:
        "This was the perfect introduction to Python. The course kept me engaged and motivated, and the practice problems were just challenging enough.",
    },
    17: {
      name: "Katrina Bell",
      review:
        "A fantastic experience! The lessons were clear, structured, and enjoyable. I now feel well-prepared to dive into Python projects on my own.",
    },
    18: {
      name: "Leonard Kim",
      review:
        "The instructor has a gift for simplifying complex ideas. Even topics like file handling and functions were easy to grasp. Great course!",
    },
    19: {
      name: "Tara Sen",
      review:
        "I loved the real-world examples throughout the course. It helped me understand where Python fits in everyday tasks and industries.",
    },
    20: {
      name: "Joshua Miles",
      review:
        "Very engaging and practical. The guidance was step-by-step, and the exercises helped reinforce every lesson. Highly recommended for beginners.",
    },
    21: {
      name: "Adriana Cortez",
      review:
        "The teaching style was friendly and supportive. I appreciated that nothing felt too fast or too slow—perfectly balanced pacing.",
    },
    22: {
      name: "Kellan Drake",
      review:
        "Clear, effective, and motivating. This course helped me build a strong understanding of Python basics and coding logic.",
    },
    23: {
      name: "Nisha Gowda",
      review:
        "The course was excellent for someone like me who’s new to programming. The instructor explained everything patiently and with helpful examples.",
    },
    24: {
      name: "Felix Morgan",
      review:
        "This course gave me the confidence to start working on my own Python projects. It’s well-structured and easy to follow from start to finish.",
    },
    25: {
      name: "Olivia Zhang",
      review:
        "An absolutely wonderful beginner course. The lessons were easy to understand and the practice tasks made me feel prepared to continue learning Python.",
    },
  },

  modules: {
    "Python Fundamentals": [
      "Installation and Environment Setup.",
      "Basic Syntax and Python Constructs.",
      "Data Types and Operators.",
      "Control Flow and Operators.",
    ],
    "Data Structures in Python": [
      "Number and Strings.",
      "List, Tuple and Dictionary.",
      "Sets and Frozen Sets.",
      "Functions and Modular Programming.",
      "Comprehension, Lambda Functions and Built-in Functions.",
    ],
    "Object-Oriented Programming": [
      "Class and Objects.",
      '"self" Argument and Class vs Instance.',
      "Methods Type & Magic Methods.",
      "Inheritance, Method Overloading, and Method Resolution Order.",
      "Closures, Decorators, Iterators and Generators.",
      "File Handling, Context Manager and Exception Handling.",
      "Modules, Packages and Pip Manager.",
    ],
    "Working with Built-In Modules": [
      "Serialization and Deserialization.",
      "Utilize math, random, time, datetime, calendar, os, glob, sys, collections, itertools, functools, http, hashlib, uuid, json and pickle.",
      "Threading and Multiprocessing.",
      "Database Management Using MySQL.",
      "Mini Project 1 - FinTech Applications.",
    ],
    "Graphical User Interface + Technology Discussion": [
      'Build desktop applications using "PyQt5" for graphical interfaces.',
      "Mini Project 2 - Building GUI Clinical Decision Support System.",
      "Discussion - Python for Future Technologies.",
      "Machine Learning, Deep Learning, Web Development, API Development, Cyber Security, Embedded Programming, Task Automation, Web Scraping",
    ],
  },
};
